import React from 'react';
import FormGroup from './components/FormGroup';
import FormLabel from './components/FormLabel';
import FormFieldset from './components/FormFieldset';
import ErrorField from './components/ErrorField';
import FormInput from './components/FormInput';
import FormSelect from './components/FormSelect/FormSelect';

type FormPropsType = {
  children: React.ReactNode;
};

const Form = (props: FormPropsType) => {
  return <>{props.children}</>;
};

Form.Fieldset = FormFieldset;
Form.Group = FormGroup;
Form.Label = FormLabel;
Form.ErrorField = ErrorField;
Form.FormInput = FormInput;
Form.Select = FormSelect;

export default Form;
